import React from 'react';
import classNames from 'classnames';

import css from './PageHeader.module.css';

/**
 * The top of every custom page: the page's one h1, an optional one-line subtitle,
 * and the page's actions on the right (they wrap under the title on a phone).
 * Keep it rendered while the page loads, is empty or fails, so the page always has its title.
 * `titleProps` go on the title element (an id and tabIndex -1, to move focus to it).
 */
const PageHeader = ({
  title,
  subtitle,
  actions,
  as: Tag = 'h1',
  className,
  titleClassName,
  titleProps,
}) => (
  <header className={classNames(css.root, className)}>
    <div className={css.text}>
      <Tag className={classNames(css.title, titleClassName)} {...titleProps}>
        {title}
      </Tag>
      {subtitle ? <p className={css.subtitle}>{subtitle}</p> : null}
    </div>
    {actions ? <div className={css.actions}>{actions}</div> : null}
  </header>
);

export default PageHeader;
